import CampaignRow from "./CampaignRow";
import SablierCampaignRow from "./SablierCampaignRow";
import StakeBanner from "./StakeBanner";
import NewsletterBlock from "./NewsletterBlock";
import HelpCenterBlock from "./HelpCenterBlock";
import {
  getOngoingCampaigns,
  getPreviousCampaigns,
  getSablierCampaigns,
} from "../utils/campaignData";

const ConnectedWalletContentNoBalance: React.FC = () => {
  const ongoingCampaigns = getOngoingCampaigns();
  const previousCampaigns = getPreviousCampaigns();
  const sablierCampaigns = getSablierCampaigns();

  return (
    <div className="max-w-[1264px] mx-auto px-4 md:px-8">
      {/* No Rewards Message Section */}
      <div className="bg-white dark:bg-[rgba(21,23,36,0.7)] min-h-[200px] md:min-h-0 rounded-xl border border-contrast-7 dark:border-contrast-3 relative mb-8 md:mb-[60px] overflow-hidden">
        <div className="flex flex-col items-center justify-center px-4 py-8 md:px-8 md:py-12 h-full relative text-center">
          {/* Message Content */}
          <div className="flex flex-col gap-4 w-full max-w-[640px]">
            <h2 className="text-contrast-3 dark:text-white text-[20px] md:text-[24px] font-medium font-geist">
              No VLR Rewards Available
            </h2>
            <p className="text-primary-papaya text-[16px] md:text-[18px] font-normal font-geist leading-[24px]">
              You currently don't have any VLR tokens to claim.
            </p>
            <div className="text-contrast-5 dark:text-contrast-6 text-[14px] font-normal font-geist leading-[21px] space-y-2">
              <p>
                Participate in ongoing campaigns to earn VLR rewards, or check
                back later for new opportunities.
              </p>
              <p>
                You can also visit our{" "}
                <button
                  onClick={() =>
                    window.open("https://help.velora.xyz/en/", "_blank")
                  }
                  className="text-contrast-3 dark:text-white font-medium hover:text-primary-azul transition-colors cursor-pointer underline"
                >
                  Help Center
                </button>{" "}
                to learn more about how to earn VLR tokens.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Campaigns and Stake Section */}
      <div className="flex flex-col md:flex-row gap-8">
        {/* Campaigns Column */}
        <div className="flex-1">
          {/* Ongoing Campaigns */}
          <div className="mb-12">
            <h2 className="text-contrast-3 dark:text-contrast-8 text-[20px] md:text-[24px] font-medium font-geist mb-6">
              Ongoing Campaigns
            </h2>
            <div className="space-y-4">
              {/* Sablier campaigns */}
              {sablierCampaigns.map((campaign, index) => (
                <SablierCampaignRow key={`sablier-${index}`} campaign={campaign} />
              ))}
              {/* Regular ongoing campaigns */}
              {ongoingCampaigns.map((campaign, index) => (
                <CampaignRow key={`regular-${index}`} campaign={campaign} type="ongoing" />
              ))}
            </div>
          </div>

          {/* Previous Campaigns */}
          <div>
            <h2 className="text-contrast-3 dark:text-contrast-8 text-[20px] md:text-[24px] font-medium font-geist mb-6">
              Previous Campaigns
            </h2>
            <div className="space-y-4">
              {previousCampaigns.map((campaign, index) => (
                <CampaignRow key={index} campaign={campaign} type="previous" />
              ))}
            </div>
          </div>
        </div>

        {/* Stake Banner */}
        <StakeBanner />
      </div>

        {/* Newsletter and Help Center Section */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-[30px] mt-8 md:mt-[60px]">
          <NewsletterBlock />
          <HelpCenterBlock />
        </div>
    </div>
  );
};

export default ConnectedWalletContentNoBalance;